export default "__VITE_ASSET__BUEG2fro__"